import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { TreatmentMethod } from 'Portals/Customer/entities'
import { TreatmentMethodRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

export class TreatmentMethodTable extends TableStore<TreatmentMethod.Basic> {
	constructor(public rootStore: RootStore) {
		super(storagePageSizeConstant('treatmentMethod'))
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: TreatmentMethodRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
}
